import { type ReactNode } from 'react';

export type TagGroupProps = {
    children: ReactNode;
    className?: string;
}

const BadgeGroup = ({ className, children }: TagGroupProps): JSX.Element => {
    return (
        <div className={`tag-group ${className}`}>
            {children}
        </div>
    );
};

export default BadgeGroup;
